import { NgModule } from '@angular/core';
import { CurrentCustomerService } from './current-customer.service';
import { MatSnackBarModule } from '@angular/material/snack-bar';

@NgModule({
  imports: [MatSnackBarModule],
  providers: [CurrentCustomerService],
})
export class CurrentCustomerModule {}
